<template>
    <div>
        <router-view />
    </div>
</template>

<script setup lang="ts">
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'

import { $url } from '#imports'
import actions from '~/pages/trucker-[id]/partner/-components/actions.vue'
const { $formatters } = useNuxtApp()
const route = useRoute()

const handleViewQuote = (quote: any) => {
  useRouter().push({ name: 'trucker-id-quote-idquote-view', params: { idquote: quote._id } })
}

const server = $url.quote.get

const quoteHeaders = [
  {
    field: 'code',
    headerName: $t('labels.code')
  },
  {
    field: 'quoteRequestCode',
    headerName: $t('labels.quoteRequestCode')
  },
  {
    field: 'transportation',
    sortable: true,
    headerName: $t('labels.transportation'),
    valueGetter: (params: any) => {
      const transportation = params.data.transportation
      if (transportation === 'CONTAINER') {
        return $t('labels.containerTruck')
      }
      if (transportation === 'NON_CONTAINER') {
        return $t('labels.nonContainerTruck')
      }
    }
  },
  {
    field: 'customerName',
    headerName: $t('labels.customer')
  },
  {
    field: 'contact.fullName',
    headerName: $t('labels.contact')
  },
  {
    field: 'contact.email',
    headerName: $t('labels.email')
  },
  {
    field: 'contact.phone',
    headerName: $t('labels.phone'),
    valueGetter: (params: any) => {
      if (params?.data?.contact?.phone) {
        return `(${params?.data?.contact.phone.code}) ${params?.data?.contact.phone.phone}`
      }
    }
  },
  {
    field: 'businessOpportunityName',
    headerName: $t('labels.businessOpportunity')
  },
  {
    field: 'commodityName',
    headerName: $t('labels.commodity')
  },
  {
    field: 'workflowName',
    headerName: $t('labels.workflow')
  },
  {
    field: 'mergeContainer',
    headerName: $t('labels.mergeContainer'),
    valueGetter: (params: any) => {
      if (params?.data?.mergeContainer) {
        return $t('labels.haveMergeContainer')
      }
      return $t('labels.notMergeContainer')
    }
  },
  {
    field: 'contCategory',
    headerName: $t('labels.cont'),
    valueGetter: (params: any) => {
      if (params.data?.transportation === 'CONTAINER' && params.data?.contCategory) {
        if (params.data?.contCategory === 20) {
          return $t('labels.20f')
        }
        if (params.data?.contCategory === 40) {
          return $t('labels.40f')
        }
        if (params.data?.contCategory === 45) {
          return $t('labels.45f')
        }
      }
    }
  },
  {
    field: 'vehicleCategoryName',
    headerName: $t('labels.vehicleType')
  },
  {
    field: 'headContainer',
    headerName: $t('labels.headContainer'),
    valueGetter: (params: any) => {
      if (params?.data?.headContainer) {
        return $t('labels.true')
      }
      return $t('labels.false')
    }
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      storeKey: 'quoteDataTable',
      storeName: 'Quote',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.view'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.quote_management),
          click: handleViewQuote
        }
      ]
    }
  }
]
</script>
